import Ajv from 'ajv';
import ajv from 'ajv';

export class SchemaValidator {
  ajv: ajv.Ajv;
  schemaValidate: ajv.ValidateFunction;

  get errors() {
    return this.schemaValidate.errors;
  }

  constructor(schema) {
    this.ajv = new Ajv({
      allErrors: true,
      $data: true,
      useDefaults: 'empty',
    });

    this.schemaValidate = this.ajv.compile(schema);
  }

  validate(obj: unknown) {
    return this.schemaValidate(obj);
  }
}
